var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_12990)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 -1.14805e-07 20 0V20H40Z",
    fill: "#2F9CEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20L20 20V40Z",
    fill: "#2F9CEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20 0C17.3736 -3.132e-08 14.7728 0.517315 12.3463 1.52241C9.91982 2.5275 7.71504 4.00069 5.85786 5.85786C4.00069 7.71504 2.5275 9.91982 1.52241 12.3463C0.517315 14.7728 -8.34853e-08 17.3736 0 20C8.34853e-08 22.6264 0.517315 25.2272 1.52241 27.6537C2.5275 30.0802 4.00069 32.285 5.85787 34.1421C7.71504 35.9993 9.91982 37.4725 12.3463 38.4776C14.7728 39.4827 17.3736 40 20 40L20 20V0Z",
    fill: "#2F9CEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4283 19.7894C15.3496 17.6726 18.6312 16.277 20.2732 15.6028C24.9614 13.6776 25.9356 13.3432 26.5705 13.3321C26.7102 13.3297 27.0224 13.3639 27.2247 13.5259C27.3954 13.6627 27.4424 13.8476 27.4649 13.9773C27.4874 14.107 27.5154 14.4025 27.4932 14.6334C27.2391 17.2688 26.1398 23.6642 25.5806 26.6159C25.3439 27.8648 24.878 28.2836 24.4269 28.3246C23.4465 28.4137 22.7021 27.685 21.7526 27.0705C20.2668 26.1089 19.4274 25.5103 17.9852 24.572C16.3185 23.4877 17.3989 22.8917 18.3488 21.9176C18.5974 21.6627 22.9168 17.7839 23.0004 17.432C23.0108 17.388 23.0206 17.224 22.9218 17.1374C22.8231 17.0508 22.6774 17.0804 22.5723 17.1039C22.4233 17.1373 20.0497 18.6862 15.4516 21.7506C14.7779 22.2073 14.1676 22.4299 13.6209 22.4182C13.0181 22.4053 11.8586 22.0817 10.9967 21.8051C9.93949 21.4658 9.09924 21.2864 9.17241 20.7102C9.21052 20.4101 9.62915 20.1032 10.4283 19.7894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_12990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.6778dc60382aded5ae6574e5fd3d30bf.svg";
export { ForwardRef as ReactComponent };